import { useContent } from "../context/ContentContext";
import { Mail, MessageCircle } from "lucide-react";
import { SocialLinks } from "./SocialLinks";

export const Contacto = () => {
  const { content } = useContent();
  const contact = content.contact || {};
  return (
  <section id="contacto" data-testid="contacto-section" className="section-anchor bg-[#050F30]/45 py-24 lg:py-32">
    <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
      <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#8AB0FF] mb-4 reveal">Contacto</p>
      <h2 className="font-serif-display text-3xl sm:text-5xl font-semibold text-white reveal">{contact.heading}</h2>
      <p className="text-neutral-200 text-base sm:text-lg mt-6 leading-relaxed reveal">{contact.text}</p>
      <div className="flex flex-wrap items-center justify-center gap-4 mt-10 reveal">
        <a
          href={`mailto:${contact.email}`}
          data-testid="contact-mailto-button"
          className="btn-primary rounded-full px-8 py-3.5 text-sm font-semibold inline-flex items-center gap-2"
        >
          <Mail size={18} /> {contact.email}
        </a>
        <a
          href={contact.whatsapp || undefined}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-whatsapp-button"
          className="btn-outline-light rounded-full px-8 py-3.5 text-sm font-semibold inline-flex items-center gap-2"
        >
          <MessageCircle size={18} /> Hablemos por WhatsApp
        </a>
      </div>
      {contact.phone && (
        <p data-testid="contact-phone" className="text-neutral-200 text-base mt-6 reveal">
          Tel. {contact.phone}
        </p>
      )}
      <div className="mt-10 reveal">
        <SocialLinks variant="dark" testId="contact-social-links" />
      </div>
    </div>
  </section>
  );
};

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#071D4D]/85 backdrop-blur-sm py-10">
    <div className="max-w-6xl mx-auto px-5 sm:px-8 flex flex-col items-center gap-6">
      <SocialLinks variant="dark" testId="footer-social-links" />
      <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-sm text-blue-200/80">
          © {new Date().getFullYear()} Yosimar de Paz · El Compa Yosi
        </p>
        <p className="text-xs uppercase tracking-[0.25em] text-[#C0C7D1]">Huntsville, Alabama</p>
      </div>
    </div>
  </footer>
);
